import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined

const EditTenderType = () => {
    const [description, setDescription] = useState('');
    const [code, setCode] = useState('');
    const [type, setType] = useState('');
    const [postingGL, setPostingGL] = useState('');
    const navigate = useNavigate();
    const { id } = useParams();

    // Fetch tender type data for editing
    useEffect(() => {
        fetch(`${BASE_URL}tendertypes/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    const tenderType = data.data;
                    setDescription(tenderType.description);
                    setCode(tenderType.code);
                    setType(tenderType.type);
                    setPostingGL(tenderType.posting_gl);
                }
            })
            .catch(error => console.error('Error fetching tender type:', error));
    }, [id]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const updatedTenderType = {
            description,
            code,
            type,
            posting_gl: postingGL
        };

        fetch(`${BASE_URL}tendertypes/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedTenderType),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    alert("Tender type updated successfully!");
                    navigate('/TenderTypeList');
                } else {
                    alert("Failed to update tender type.");
                }
            })
            .catch(error => console.error('Error updating tender type:', error));
    };

    return (
        <div id="main">
            <div className="page-heading">
                <h3>Edit Tender Type</h3>
            </div>
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="description"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="code" className="form-label">Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="code"
                                            value={code}
                                            onChange={(e) => setCode(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="type" className="form-label">Type</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="type"
                                            value={type}
                                            onChange={(e) => setType(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="postingGL" className="form-label">Posting GL</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="postingGL"
                                            value={postingGL}
                                            onChange={(e) => setPostingGL(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-primary">Save</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditTenderType;
